<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Payment Update</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link to="/report/view/vendor">Report</router-link> /
      <router-link :to="{ name: 'report-update', params: { id: id } }"
        >Overall Report</router-link
      >
      /
      <b>Update Pay</b>
    </div>
    <!-- End of breadcrumbs -->
    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class="">
              <h4 class="card-title mb-3"></h4>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <!-- cashout at -->
                  <label for="date">Cashed out at:</label>
                  <datepicker id="date" v-model="cashed_out_at"></datepicker>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <label for="payment">Payment Voucher:</label>
                  <input
                    class="form-control"
                    id="payment"
                    type="text"
                    v-model="payment_voucher"
                  />
                </div>
              </div>

              <div class="row" style="margin-top: 30px;">
                <div class="col-12 text-center">
                  <button
                    class="btn btn-lg btn-success col-2"
                    @click="updatePay()"
                  >
                    Update
                  </button>
                  <span class="col-3"></span>
                  <!-- <span class="col-3"></span> -->
                  <!-- <button class="btn btn-lg btn-danger col-2">Cancel</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import datepicker from "vuejs-datetimepicker";
import moment from "moment";

export default {
  name: "vendor-payout",
  components: {
    datepicker
  },

  data() {
    return {
      id: "",
      cashed_out_at: "",
      payment_voucher: ""
    };
  },

  methods: {
    updatePay() {
      if (!this.checkToken()) {
        return;
      }

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }

        // console.log(this.humanToComputerDate(this.cashed_out_at))
        // return;

        axios
          .post(
            axios.lpsURL + "/payout/update",
            {
              id: this.id,
              cashed_out_at: this.cashed_out_at,
              payment_voucher: this.payment_voucher
            },
            {
              headers: {
                Authorization: "Bearer " + this.checkToken()
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              });
              return;
            }

            swal({
              icon: "error",
              text: res.data.message
            });
            return;
          });
      });
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null) {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;

      return token;
    }
  },

  created() {
    this.id = this.$route.params.id;
  },

  mounted() {}
};
</script>
